import { Label, PagedSingleSelectField, Row, SelectDefaultOption, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { contactViewService } from "../shared/api/contactViewService";

interface Props {
	name: string;
	label: string;
	onChange?: () => void;
	required?: boolean;
	clearable?: boolean;
	disabled?: boolean;
}

const fetchConfig = laravelServiceSelectFetchConfig(contactViewService);

export const ProfileContactViewSelect: FC<Props> = (props) => {
	const { t } = useTranslation();
	return (
		<PagedSingleSelectField
			{...props}
			fetchConfig={fetchConfig}
			renderOption={(contactView, isSelected, isHovered) => (
				<SelectDefaultOption $isSelected={isSelected} $isHovered={isHovered}>
					<Row $columnGap={2}>
						{contactView.name}
						{!contactView.containsPrimaryContactAttributes && (
							<Label size="small" color="danger">
								{t("Missing contact attributes")}
							</Label>
						)}
					</Row>
				</SelectDefaultOption>
			)}
		/>
	);
};
